import { AbodeAggregateMarketConditions } from '@aloft/toolkit-shared';
import {
  LabelList,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';
import { Flex, Typography } from '@aloft/toolkit-sui';
import { computeTrend } from '../../utils/computeTrend.ts';


export const MonthsOfHousingSupply = ({
  data,
}: {
  data: AbodeAggregateMarketConditions;
}) => {
  const chartData: {
    month: string;
    monthsOfHousingSupply: number;
  }[] = data.monthlyData.filter((item) => item.months_supply !== null).map((item => ({
    month: item.month.substring(0, 7),
    monthsOfHousingSupply: item.months_supply ?? 0,
  })));
  const maxValue = Math.max(...chartData.map(item => item.monthsOfHousingSupply));
  const trendSeries = computeTrend(chartData, 'monthsOfHousingSupply');
  const trendSeriesColor =
    (trendSeries[trendSeries.length - 1] || { monthsOfHousingSupply: 0 }).monthsOfHousingSupply >= (trendSeries[0] || { monthsOfHousingSupply: 0 }).monthsOfHousingSupply
      ? '#FF0000'
      : '#00B050';

  return (
    <Flex
      flexDirection="column"
      className="commentary-chart-container"
      gap={2}
      width="100%"
      maxWidth="1400px"
    >
      <Typography variant="h3">Months of Housing Supply</Typography>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart
          data={chartData}
          margin={{ top: 80, right: 40, left: 0, bottom: 0 }}
        >
          <YAxis domain={[0, maxValue]} tick={false} axisLine={false} />
          <XAxis dataKey="month" interval={0} fontSize={12} tickLine={false} />
          <Line type="linear" dataKey="monthsOfHousingSupply" stroke="#3455DB" strokeWidth={2} dot={{ r: 3 }} >
            <LabelList dataKey="monthsOfHousingSupply" position="top" fontSize={12} offset={10} />
          </Line>
          <Line type="linear" data={trendSeries} dataKey="monthsOfHousingSupply" stroke={trendSeriesColor} strokeWidth={1} dot={false} strokeDasharray="5 5" />
        </LineChart>
      </ResponsiveContainer>
    </Flex >
  );
}
